export let AccordionMixins = {
    methods: {
        accordionClose: function (id) {
            this.$root.$emit("bv::toggle::collapse", id);
        }
    },
    mounted() {
        this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
            const controlElement = document.querySelector(`[aria-controls="${collapseId}"]`)
            const tabpanelElement = document.getElementById(collapseId)

            if (controlElement) {
                if (isJustShown) {
                    controlElement.setAttribute('aria-selected', 'true')
                } else {
                    controlElement.setAttribute('aria-selected', 'false')
                }
            }

            if (tabpanelElement) {
                if (isJustShown) {
                    tabpanelElement.setAttribute('aria-expanded', 'true')
                    tabpanelElement.focus()
                } else {
                    tabpanelElement.setAttribute('aria-expanded', 'false')
                }
            }
        })
    }
}